import * as React from "react";
const SvgCheckmarkLightCircle = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M20 4C11.163 4 4 11.163 4 20s7.163 16 16 16 16-7.163 16-16S28.837 4 20 4Zm0 29.935c-7.656 0-13.935-6.197-13.935-13.935 0-7.656 6.197-13.935 13.935-13.935 7.656 0 13.935 6.197 13.935 13.935 0 7.656-6.197 13.935-13.935 13.935Zm9.137-17.739-11.643 11.55a.774.774 0 0 1-1.095-.004l-5.54-5.585a.774.774 0 0 1 .004-1.095l.55-.545a.774.774 0 0 1 1.094.004l4.45 4.486 10.545-10.46a.774.774 0 0 1 1.095.005l.545.55c.301.303.299.793-.005 1.094Z" }));
export default SvgCheckmarkLightCircle;
